import { Component } from 'react';
import RepayDate from './RepayDate';
import RepayMoney from './RepayMoney';
import { cloneChildType, hasChildType } from './ReactHelper';
import RepayDescription from './RepayDescription';
import RepayLabel from './RepayLabel';
import styles from './RepaymentSummaryItem.module.css';

class RepaymentSummaryItem extends Component {
    renderDescription() {
        const { children } = this.props;
        if (hasChildType(children, RepayDescription)) {
            return cloneChildType(children, RepayDescription, {});
        }

        return null;
    }

    render() {
        const { children } = this.props;

        const repayLabel = cloneChildType(children, RepayLabel, {});
        const amount = cloneChildType(children, RepayMoney, {});
        const date = cloneChildType(children, RepayDate, {});
        const description = this.renderDescription();

        return (
            <div className={styles.RepaymentSummaryItem}>
                <div className={styles.nextRepaymentContainer}>
                    <div className={styles.nextRepaymentLabel}>
                        {repayLabel}
                    </div>
                    <div className={styles.nextRepaymentDate}>{date}</div>
                </div>
                <div className={styles.amountLine}>{amount}</div>
                {description}
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default RepaymentSummaryItem;
